// removed by extract-text-webpack-plugin
module.exports = {"root":"_1PDrA"};